<template>
    <div class="w-100">
        <Upload
            :ref="(e) => (refs.upload = e)"
            accept="image/*"
            list-type="picture-card"
            :showUploadList="false"
            :beforeUpload="() => false"
            @change="onChange"
            :openFileDialogOnClick="data.openFileDialogOnClick"
            :disabled="disabled"
        >
            <div class="upload-body">
                <div class="upload-action" v-if="hasImage && !disabled">
                    <Row class="h-100" justify="end" align="top">
                        <Col>
                            <CIcon class="text-danger mx-1" file="delete.svg" @click="onClickDelete"></CIcon>
                        </Col>
                    </Row>
                </div>
                <img
                    class="w-100"
                    v-if="value?.blob && value?.type && value?.name"
                    :src="`data:${value.type};base64,${value.blob}`"
                    :alt="value.name"
                />
                <img class="w-100" v-else-if="value?.url" :src="parseUrl(value.url)" :alt="value.name" />
                <div v-else>
                    <CIcon file="upload.svg" class="text-20"></CIcon>
                    <div class="ant-upload-text">{{ $t("button.upload") }}</div>
                </div>
            </div>
        </Upload>
    </div>
</template>

<script>
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { Upload, Row, Col } from "ant-design-vue";
import { getBase64 } from "../../../../utils/file";
import { parseUrl } from "../../../../utils/util";

export default defineComponent({
    components: {
        Upload,
        Row,
        Col,
        CIcon: defineAsyncComponent(() => import("../../../icon/CIcon")),
    },
    props: {
        value: {},
        group: {},
        disabled: {},
    },
    emits: ["update:value"],
    setup(props, { emit }) {
        const data = reactive({ openFileDialogOnClick: true });
        const refs = reactive({ upload: null });
        const onChange = (e) => {
            getBase64(e.file, (fileModel) => {
                emit("update:value", { group: props.group, ...fileModel, isSave: true });
            });
        };
        const hasImage = computed(() => (props.value?.blob && props.value?.type && props.value?.name) || props.value?.url);
        const onClickDelete = () => {
            data.openFileDialogOnClick = false;
            emit("update:value", null);
            setTimeout(() => (data.openFileDialogOnClick = true), 500);
        };
        return { data, refs, onChange, parseUrl, hasImage, onClickDelete };
    },
});
</script>

<style scoped>
.upload-body {
    position: relative;
}

.upload-body .upload-action {
    display: none;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
}

.upload-body:hover .upload-action {
    display: block;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.5);
}
</style>

<style>
.w-100 .ant-upload {
    width: 100% !important;
}
</style>
